export default __webpack_public_path__ + "static/media/View_carousal_Icon.63f70456.svg";